module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e39111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c15_r1#Anch00311",
      "id": "Anch0027"
    }
  }, [_vm._v("CHAPTER 1"), _c('br'), _vm._v(" The Missing Ingredient ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e39911"
    }
  }, [_c('b', [_vm._v("“Please, please, please, please, ")]), _c('b', [_c('i', [_vm._v("please,” ")])]), _vm._v("Shirli Hunt practically prayed. “Don’t sing anything patriotic.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41711"
    }
  }, [_vm._v("Unfortunately, that’s exactly what the teacher was planning to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e42211"
    }
  }, [_vm._v("The year was 1935. A new wave of Americanism was spreading across the land, and, like so many people in that moment in history, Shirli Hunt’s father was passionately patriotic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e43711"
    }
  }, [_vm._v("“Shirli, you should be very proud to be an American,” her father told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e45011"
    }
  }, [_vm._v("Shortly before World War II, a pro-Hitler German had walked into a barber shop Shirli’s dad frequented and started praising the Third Reich. Shirli’s dad leapt out of the barber chair—shaving cream still covering half of his face—and pushed the man up against the wall. “If you don’t believe in America, you can leave,” he half shouted, “but you’re not going to stand here and talk against this country.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e48011"
    }
  }, [_vm._v("Whenever a song was played—on the wireless or at public outings—and America was even "), _c('i', [_vm._v("mentioned")]), _vm._v(", Shirli’s father insisted that the entire Wingham family stand to show their respect. They could be in the middle of dinner with guests, but if a song came on the radio in the background (“In those days, people had the radio going all the time,” Shirli remembers), Shirli’s entire family pushed back their chairs and stood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e52312"
    }
  }, [_vm._v("That’s what led to Shirli’s desperate plea. At the time, she was attending middle school, and her teacher was leading the class in several folk songs: “I’ve Been Working on the Railroad,” “Flow Gently, Sweet Afton,” “Oh! Susanna.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e54612"
    }
  }, [_vm._v("So far, so good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e55312"
    }
  }, [_vm._v("Then the teacher announced, “Let’s sing ‘America, the Beautiful.’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e55812"
    }
  }, [_vm._v("Shirli felt like she was going to melt in her seat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e56712"
    }
  }, [_vm._v("“I sat for one stanza thinking, "), _c('i', [_vm._v("I don’t have to get up because my dad isn’t ")]), _c('i', [_vm._v("here; he’ll never know.")]), _vm._v(" ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e58412"
    }
  }, [_vm._v("After all, she was sitting in the front row. Everybody could see her, and the last thing a thirteen-year-old girl wants is to be embarrassed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e59212"
    }
  }, [_vm._v("But the pressure became too great. Shirli could see her father’s face, and she could hear his forceful words: "), _c('i', [_vm._v("When you walk out that door, you ")]), _c('i', [_vm._v("walk out representing the Wingham family, and don’t you forget it!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e61412"
    }
  }, [_vm._v("Suddenly, a room full of seventh graders paled in comparison to the shadow of that forceful, loving man. As the class broke into the second stanza, Shirli rose on weak knees and wobbled to her feet. She just couldn’t help herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e63312"
    }
  }, [_vm._v("After the song, Shirli’s actions created a bit of discussion. One of the boys argued with the teacher, “Shirli didn’t have to stand. We weren’t singing ‘The Star-Spangled Banner.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e65212"
    }
  }, [_vm._v("“Oh yes, I did have to stand,” Shirli shot right back. “You don’t know my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e66512"
    }
  }, [_vm._v("Sixty years later, Shirli’s eyes still glisten as she looks back on that incident and explains, “My relationship as that man’s daughter was one of honor. As young as I was, I honored him because he was such a trustworthy man. Above all, I didn’t want to disappoint him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e68913"
    }
  }, [_vm._v("If you ever wondered how much impact a father can have on a daughter, I urge you to travel to Bellingham, Washington, and look into the eyes of Shirli Hunt. The decades haven’t even begun to dim her passionate respect, love, and honor for the man who raised her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e70613"
    }
  }, [_vm._v("In all my years of practice and of speaking to literally millions of people through radio and television and at seminars, one fact has impressed me as much as anything else: Fathers leave an indelible imprint on the lives of their daughters. They shape their daughters in ways so profound that many women live with unwritten rules they’ve never thought to question. These rules were ingrained into them so deeply, many women don’t realize that though they may graduate from college, get married, and even give birth to a half-dozen males, they’ll still never stop being Daddy’s girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e73913"
    }
  }, [_vm._v("A woman’s relationship with her father, more than any other relationship, is going to affect her relationships with all other males in her life—her bosses, coworkers, subordinates, sons, husband, brothers, pastors, college professors, and even Hollywood movie stars. (You tell me if a woman chooses Dennis Rodman over Michael Jordan, and I’ll give you an accurate picture of her father!) There’s not a single relationship that isn’t indelibly stamped—for good or for ill—by the man known as Daddy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e77513"
    }
  }, [_vm._v("Though this book is written primarily for men, I know a number of women will pick it up just to see what we men are talking about. If you are one of these women, I think you’ll discover the depth of one man’s imprint on your life. By understanding the father-daughter bond, you’ll be able to help repair a damaged heart or strengthen the blessings of a healthy relationship. You’ll gain new insight into your marriage and become a better mother to your boys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e80113"
    }
  }, [_vm._v("For the men, well, guys, allow me to let you in on a little secret: You have no idea how much you can improve your love life simply by being a good parent to your wife’s daughters. Whenever I tell inspiring father-daughter stories during my seminars, I am treated to a loud and spontaneous feminine “ahhh.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e83114"
    }
  }, [_vm._v("Women just can’t get enough of these father-daughter stories, and most men don’t realize what they’re missing by not paying more attention to their little girls. If you want a sexually eager wife, take your daughter on a date. You may be follicly challenged, with just a few strands of hair desperately clinging to a shining crown. You may carry enough extra pounds to keep a hot air balloon on the ground (all by yourself)! But if you show appropriate love and affection to your daughter, I guarantee you that your wife will find herself sighing, “I’m so glad I married that man.” (And she may even think up some very creative ways to tell you that.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e86614"
    }
  }, [_vm._v("The father-daughter relationship is the key to every woman’s aching heart. It’s the genesis of every grown woman’s sighs. It’s also, unfortunately, the missing ingredient in many lost souls.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e88214"
    }
  }, [_c('b', [_c('i', [_vm._v("An Essential Ingredient ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e88714"
    }
  }, [_vm._v("My daughter was determined to bake her parents a cake on their anniversary, and she didn’t want any help. She could do it herself, thank you very much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e90014"
    }
  }, [_vm._v("It was awful, to tell you the truth, just plain awful. But I knew the day would come when this daughter of mine would be able to make chocolate chip cookies and cakes that actually tasted good, so I didn’t want to discourage her on her first try.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e91714"
    }
  }, [_vm._v("Of course, matters weren’t helped by the fact that she "), _c('i', [_vm._v("broiled ")]), _vm._v("the cake instead of baked it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e93114"
    }
  }, [_vm._v("“I just turned the oven "), _c('i', [_vm._v("on,” ")]), _vm._v("she explained. “How was I supposed to know the other dial was set to broil?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e94815"
    }
  }, [_vm._v("Fair enough. After she scraped off the top crust, the “cake” was about an inch high. She piled it with frosting to remind us that it wasn’t brownies, then served a piece to my wife and me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e96115"
    }
  }, [_vm._v("“This is so . . . "), _c('i', [_vm._v("moist,")]), _vm._v("” Sande, my wife, said. “I can’t believe how moist this is.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e97815"
    }
  }, [_vm._v("“Delicious, honey,” I added. “Just delicious. Could I get another cup of milk? . . . While you are at it, why don’t you just bring the entire carton?” Our daughter’s smile was worth the deception.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e99315"
    }
  }, [_vm._v("The next morning Sande was rummaging through the cupboards.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e100115"
    }
  }, [_vm._v("“Where’s the powdered milk?” Sande asked. “I bought a whole box just a few days ago, and now I can’t find it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e101415"
    }
  }, [_vm._v("“Powdered milk?” my daughter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e102215"
    }
  }, [_vm._v("Sande turned around just in time to see my daughter’s eyes dart quickly to the infamous “cake.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e103415"
    }
  }, [_vm._v("“You mean that wasn’t flour?” my daughter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e104115"
    }
  }, [_vm._v("Sande burst out laughing, and our daughter joined her. No wonder the cake seemed so moist!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e105315"
    }
  }, [_vm._v("Cakes are relatively easy to make, but if you change just one essential ingredient, like flour, the result will be a disaster. The fundamental ingredient in any woman’s life is her relationship with her father. If that is missing or distorted, she will have to spend a good bit of time and energy overcoming the deficit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e107415"
    }
  }, [_vm._v("Research clearly demonstrates that a father sets up a daughter for success. Normally, I’m not a big fan of “professional research,” as I’ve discovered that most professional opinions resemble armpits:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e108515"
    }
  }, [_vm._v("Everyone has at least two of them, and they usually stink. Most psychologists and social scientists couldn’t agree on how to spell "), _c('i', [_vm._v("father")]), _vm._v(", much less describe one accurately, but there is one thing that brings them to consensus. Rutgers sociologist David Popenoe, author of "), _c('i', [_vm._v("Life ")]), _c('i', [_vm._v("Without Father")]), _vm._v(", wrote, “I know of few other bodies of evidence (in social science) that lean so much in one direction as does the evidence about family structure.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d1",
      "id": "a1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e113216"
    }
  }, [_vm._v("That evidence shows that a father’s relationship to his daughter is one of the key determinants in a woman’s ability to enjoy a successful life and marriage. Popenoe says that involved fathers boost academic achievement, promote psychological health, increase a child’s empathy for others, and even bolster the status of women! If more men were involved in their daughters’ lives, he asserts, more women would be leading national governments, and fewer women would be frequenting shelters for abused spouses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e116416"
    }
  }, [_vm._v("Ernestine Brown, who studies African-American families at the University of California at Berkeley, warned, “Without warmth and support from their fathers, girls may grow up feeling isolated or aggressive.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d2",
      "id": "a2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Always eager to catch the next wave, politicians have gone after the role of fathers in a big way. Republican Vice President Dan Quayle set off a firestorm in the early 1990s when he attacked a sitcom, "), _c('i', [_vm._v("Murphy ")]), _c('i', [_vm._v("Brown, ")]), _vm._v("which insinuated that fathers don’t matter and that intentional single motherhood is okay. Within months, newly-elected Democratic President Bill Clinton joined the chorus supporting Quayle’s contention, saying, “The biggest social problem in our society may be the growing absence of fathers from their homes, because it contributes to so many other social problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e122916"
    }
  }, [_vm._v("Conservatives may have a hard time accepting much of what political strategist James Carville says, but at least he understands the father relationship: “Number one is, the paycheck, stupid. Number two is, daddies matter, big time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e125016"
    }
  }, [_vm._v("And a 1999 Teen/Parent Drug Survey found that teenagers who live in two-parent families and have fair or poor relationships with their dads are at a 60 percent greater risk of smoking, drinking, and using drugs than teens from single-mother households.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e127117"
    }
  }, [_vm._v("In this fifth annual survey, financed by the National Center on Addiction and Substance Abuse (CASA) at Columbia University, 71 percent of teens said they had excellent or very good relationships with their mothers, but only 58 percent reported such relationships with their fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e129017"
    }
  }, [_vm._v("Joseph Califano Jr., former U.S. secretary of Health, Education, and Welfare and current president of CASA, said these statistics should be a “wake-up call for dads across America” to become more engaged with their children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e131117"
    }
  }, [_vm._v("Unfortunately, many dads still leave child-rearing up to their wives and assume that the voice of the father can’t add anything more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e132117"
    }
  }, [_vm._v("“We can’t leave it up to Mom,” Califano cautioned. “She’s doing a terrific job, but she can’t do it alone.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d3",
      "id": "a3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e133717"
    }
  }, [_vm._v("Democrat or Republican, president or pundit, people now know:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e134217"
    }
  }, [_vm._v("Daddies "), _c('i', [_vm._v("count")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e135317"
    }
  }, [_vm._v("Why? Well, daddies treat kids differently; they provide a necessary complement to a mother’s loving care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e136317"
    }
  }, [_vm._v("Go to a public pool some time and watch a mother gently lead her child as the precious little tot floats carefree on an inner tube, calm, serene, charmed by life. The mother will invariably hold precious Buford or Betsy with two hands, carefully guiding the inner tube away from any wave higher than three inches. If she could, Mom would find a way to let her child swim without getting wet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e138817"
    }
  }, [_vm._v("Now listen for the screams, and chances are, you’ll find a daddy behind them. Suddenly a young girl has become a projectile, thrown out of her daddy’s arms and up into the air while another eager youngster shouts out, “Now do it to me! I’m next! Do it to me, too, Daddy!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140918"
    }
  }, [_vm._v("Mom runs up to Dad and says, “Harold, are you "), _c('i', [_vm._v("sure ")]), _vm._v("that’s safe?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e142018"
    }
  }, [_vm._v("“Ah, she’s fine, Edith, she’s fine. Kids this age bend; they don’t break,” he responds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e143018"
    }
  }, [_vm._v("Mom clicks her tongue in disgust, armed with stories of at least a dozen kids who have been scarred beyond recognition by being thrown in a pool, but secretly she thinks, "), _c('i', [_vm._v("I’m so glad I married that man. Look at ")]), _c('i', [_vm._v("the way he plays with his kids.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e144818"
    }
  }, [_vm._v("A woman recognizes that she brings certain qualities and characteristics to the parenting task and that her testosterone-toting husband brings an entirely different perspective and approach, and she realizes that both an active father and mother are crucial for kids to get the best start in life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e146418"
    }
  }, [_vm._v("This goes far beyond boys needing a male role model. In fact, I would argue that a child’s most important relationship is the one with the parent of the opposite sex.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d7e148018"
    }
  }, [_c('b', [_c('i', [_vm._v("The Most Important Relationship ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e148618"
    }
  }, [_vm._v("“Dear Dr. Leman,” the letter read. “I just wanted to thank you for a great idea that you mentioned when you spoke at our church last fall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e149718"
    }
  }, [_vm._v("You said we should have more ‘dads and daughters,’ ‘moms and sons’ events. So I decided to give it a try, and we sponsored a Sweetheart Dinner for dads and daughters this past Friday. We had originally hoped that we would have 50 people attend. On Friday, we served dinner to 274 people! . . . Thanks again for the terrific idea!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e151718"
    }
  }, [_vm._v("It’s not that there’s anything "), _c('i', [_vm._v("wrong ")]), _vm._v("with mother-daughter banquets or father-son outings; it’s just that the church seems blind to the even greater importance of cross-gender relationships between parent and child. A woman’s marriage says far more about her relationship to her father than it ever will about her relationship to her mother. A man’s marriage is overwhelmingly influenced not by the times he played catch with his dad but by the times he spent alone with Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e155119"
    }
  }, [_vm._v("Every husband either pays the price or reaps the rewards sown by his father-in-law. A positive example is Atlanta Falcons quarterback Chris Chandler. When Chris met Diane Brodie, the woman who became his wife—daughter of the legendary San Francisco 49ers quarterback John Brodie—he was a second or third string quarterback, just barely hanging on in the league. He had played on three teams in five years, and his future looked bleak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e158719"
    }
  }, [_vm._v("Just a few years later, in 1998, Chandler threw for 3,154 yards in one season, including 25 touchdown passes, leading the Atlanta Falcons to a 14-2 regular season and Super Bowl XXXIII. The reason for Chandler’s turnaround? Listen carefully to what he told "), _c('i', [_vm._v("USA Today: ")]), _vm._v("“I’d never had anybody like Diane to talk to, to listen to me. "), _c('i', [_vm._v("She and her father are so ")]), _c('i', [_vm._v("much alike—")]), _vm._v("upbeat and high energy. They renewed my belief in myself, which allowed me to take my game to a higher level . . .”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d4",
      "id": "a4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e162619"
    }
  }, [_vm._v("Chris benefited greatly from marrying a woman who has a great relationship with her father. That man instilled the type of personality in his daughter that helped Chris to achieve his full potential—and more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e163919"
    }
  }, [_vm._v("There are also negative experiences. While Natalie Cole, daughter of the phenomenally successful singer Nat King Cole, and best-selling recording artist in her own right, loved her father dearly (she told a "), _c('i', [_vm._v("Good Housekeeping ")]), _vm._v("reporter in 1992 that she “adored” him), she sometimes felt “left out and jealous.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e166319"
    }
  }, [_vm._v("“In my child-mind there was doubt as to who my father preferred— his fans or me,” she said. “It seems I was always angry or hurt because he was never around as much as I needed him to be. I wanted so much more of him than he was able to give.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e168420"
    }
  }, [_vm._v("Natalie had a difficult time dealing with the frequent absences of a touring father. And then, when Natalie was just fifteen years old, her father left for good, this time through death.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e169720"
    }
  }, [_vm._v("Nat’s departure and earlier habitual absences left an indelible, negative imprint on his daughter. “Since I unconsciously thought men would leave me as my father always had, I would leave first, thereby ensuring I wouldn’t get hurt,” Natalie told "), _c('i', [_vm._v("Good Housekeeping. ")]), _vm._v("The reporter, Alan Ebert, noted, “In the decade between her first marriage and her current one . . . Natalie left every man with whom she had been involved.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d5",
      "id": "a5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e173020"
    }
  }, [_vm._v("Both husband and wife need to know the pervasive influence passed down by the parent of the opposite sex. The father-daughter or mother-son relationship will greatly influence whom a person marries and how well they do within that marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e174820"
    }
  }, [_vm._v("A silent, noninvolved dad leaves women clueless about men. (A distant mother leaves men without any understanding of women.) Who better to tell a young woman what is going on inside a male when she lets a boy kiss her than her very own dad, who happens to own the same equipment as the girl’s suitor?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177020"
    }
  }, [_vm._v("I’m constantly reminding women of something that very few of them understand on their own. A husband’s primary need is sexual fulfillment. Notice I didn’t say "), _c('i', [_vm._v("sex")]), _vm._v(". I said "), _c('i', [_vm._v("sexual fulfillment. ")]), _vm._v("We’ll talk about the difference in a later chapter. The way most mothers pull young brides aside and explain “the wedding night,” women would never guess what I’m talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e180320"
    }
  }, [_vm._v("Women’s primary need is . . . gardening. Well, maybe not gardening, but digging around in the dirt actually did precede sex in a national study of women’s preferred activities. The problem is, most women want men to intuitively understand their needs. They don’t want to tell their husbands what they need; they just want their husbands to "), _c('i', [_vm._v("know.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e182721"
    }
  }, [_vm._v("Most husbands remain clueless, and so thirty years later, when they take Junior aside on his wedding day and try to explain things, the poor young man inherits a game plan that might work on Jupiter but will have absolutely no relevance on this planet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e184421"
    }
  }, [_vm._v("In both cases—with mothers talking to daughters and fathers talking to sons—ignorance is passed on like a communicable disease, and marriages become sick accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e185921"
    }
  }, [_vm._v("The cure? Strengthen father-daughter, mother-son relationships. Let a woman tell a young man what a young wife needs. Let a father tell a young woman what her husband wants. The successful team needs a balanced attack, both offense and defense. We need to break down the ridiculous wall that keeps both sexes divided.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e187821"
    }
  }, [_vm._v("This is why I often urge families to turn off the television—not because of what they’ll see, but because of what they "), _c('i', [_vm._v("won’t ")]), _vm._v("see. On today’s television shows, kids won’t see men of responsibility. They won’t view husbands and wives who respect each other. The kids won’t watch other children honor their parents. They’re far more likely to see a stupid, clueless dad whom everybody puts up with and who is recognized as the family joke.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191021"
    }
  }, [_vm._v("It is insidious for kids to see dads play the butt of every silly line in nightly sitcoms. Homer Simpson has replaced Ward Cleaver as America’s stereotypical dad. The National Fatherhood Initiative reviewed prime-time programming on the ABC, NBC, CBS, Fox, and WB networks during the late autumn of 1998. They found that fathers are central, recurring characters on only 15 of 102 network comedies or dramas, and "), _c('i', [_vm._v("only 4 ")]), _vm._v("of these programs portray the dad as both competent and caring. This means that slightly less than 4 percent of prime-time television shows give an accurate portrayal of what a father should be."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d6",
      "id": "a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" This has been going on for some time. Earlier in the 1990s, on the ABC miniseries "), _c('i', [_vm._v("The Women of Brewster Place, ")]), _vm._v("a young, shy woman laments that she doesn’t have a husband. An older, “wiser” woman responds, “Well, I’ve had five, and you ain’t missing much.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e198422"
    }
  }, [_vm._v("Even the evening news contains attacks on dads. One social “expert” actually suggested that, when given a choice between welfare payments and husbands, women should choose welfare payments, since welfare payments are generally more reliable and less bothersome than men."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#d7",
      "id": "a7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e198922"
    }
  }, [_vm._v("A man’s importance as a father needs to be respected for the woman’s well-being as much as anything else. A woman needs to reach up toward her father before she will be free to reach out toward her husband or down toward her son.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e201922"
    }
  }, [_vm._v("In the coming pages, we’re going to further explore the tremendous difference that a daddy makes. One way for a woman to look at her father is to consider him as the man who made her what she is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e203222"
    }
  }, [_vm._v("In Section Two, we’ll look at “Daddy’s Duty.” We’ll explore the marks of a healthy father-daughter relationship and we’ll examine the key components involved in giving a daughter her best possible start in life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e204322"
    }
  }, [_vm._v("In Section Three, “Daddy’s Dilemmas,” we’ll touch on the difficult subjects: how a father can talk to his daughter about sex and physical development; what to do when Mom and daughter start competing for Dad’s attention; and how a father can make a successful transition to becoming a father-"), _c('i', [_vm._v("in-law")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e206722"
    }
  }, [_vm._v("Along the way, we’ll meet men and women who have struggled with these issues. And I’ll tell you how I’ve tried to father my four daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e208023"
    }
  }, [_vm._v("I have to admit, most of these stories are positive. But, hey, these are my memories. I like to see “the cub,” as I call myself, as a hero. After all, there are many times when I’m not. To get the unedited version, you need to speak directly to my four girls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e209623"
    }
  }, [_vm._v("Throughout the book you’ll find practical help and come across a few stories that may make you laugh and even cry. But more than anything else, I hope this book will reawaken in you the wonder of the mysterious relationship that exists between a daughter and her daddy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f8861a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lema_9781418514020_epub_c17_r1.vue
// module id = 75
// module chunks = 0